import React, { useEffect, useRef, useState } from 'react';
import {
   Box,
   Button,
   Checkbox,
   Divider,
   FormControlLabel,
   Grid,
   IconButton,
   List,
   ListItem,
   Paper,
   Tooltip,
   Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faUser } from '@fortawesome/free-solid-svg-icons';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import {
   faFileEdit,
   faPrint,
   faTrashAlt,
} from '@fortawesome/pro-duotone-svg-icons';
import { Layout } from '../../../configs/ui/constant';
import Axios from 'axios';
import Circle from '../../Chart/Circle';
import { QRCode } from 'react-qrcode-logo';
import Logo from '../../../assets/mocks/img/logo.png';
import styled from '@emotion/styled';
import ReactToPrint from 'react-to-print';
import ErrorPopup from '../../Error/ErrorPopup';
import LoadingPopup from '../../Loading/LoadingPopup';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';
import dayjs from 'dayjs';
import { ActLable } from '../../Status/StatusLabel';
import { GSBtoWording } from "../../../configs/helpers/GSBtoWording"

const MyChip = styled('div')`
   padding: 0 0.5rem 0;
   display: inline-flex;
   align-content: center;
   align-items: center;
   justify-content: center;
   background-color: ${(props) => props.bgColor};
   border-radius: 2.5px;
   margin-right: 1rem;
   font-weight: 700;
   color: #fff;
`;
const MyChipPrint = styled('div')`
   height: 40px;
   width: 40px;
   display: inline-flex;
   align-content: center;
   align-items: center;
   justify-content: center;
   background-color: ${(props) => props.bgColor};
   border-radius: 50%;
   margin-right: 1rem;
   color: #fff;
   font-family: 'GSB';
`;
const MySpan = styled('span')`
   width: 100%;
   margin: 0 0.5rem;
`;
const DataSpan = styled('span')`
   font-weight: 700;
   margin: ${(props) => props.margin};
`;
const PaperPrint = styled('div')`
   width: 100%;
   text-align: center;
`;
const TitlePaper = styled('div')`
   width: 100%;
   background-color: ${Layout.primary};
   color: #fff;
`;
const TextPrint = styled('div')`
   font-size: 1.25rem;
   color: #515151;
   margin: 0;
   font-weight: 700;
   padding: 0.5rem;
`;

const TextValuePrint = styled('div')`
   font-size: 1.25rem;
   color: #000;
   margin: 0;
   font-weight: 700;
   padding: 0.5rem;
`;
const TextValuePrintH = styled('h2')`
   color: #000;
   margin: 0;
`;
const TextValuePrintB = styled('div')`
   font-size: 1.75rem;
   color: #000;
   margin: 0;
   font-weight: 700;
   padding: 0.5rem;
`;
const CenterSpace = {
   display: 'flex',
   alignContent: 'center',
   alignItems: 'center',
   justifyContent: 'space-between',
};

const ComponentToPrint = ({ printRef, nameActivity, valueQR, data }) => (
   <div style={{ display: 'none' }}>
      <div ref={printRef}>
         <PaperPrint>
            <TitlePaper>
               <Typography variant={'h4'}>GSB Way Point</Typography>
            </TitlePaper>
            <br />
            <Box {...CenterSpace}>
               <Box width={1 / 2}>
                  <QRCode size={250} value={valueQR} logoImage={Logo} />
               </Box>
               <Box width={1 / 2} textAlign={'left'}>
                  <TextValuePrint>
                     {`กิจกรรม : ${data.activityCode} : ${data.activityName}`}
                  </TextValuePrint>
                  <TextValuePrint>
                     หลักเกณฑ์ : {data.ruleCode} : {data.ruleName}
                  </TextValuePrint>
                  <div>
                     <TextValuePrint>{`ระหว่างวันที่ ${dayjs(
                        new Date(data.startDate),
                     ).format('DD MMM BB HH:mm')} น. ถึง ${dayjs(
                        new Date(data.endDate),
                     ).format('DD MMM BB HH:mm')} น.`}</TextValuePrint>
                  </div>
                  {data.venue && (
                     <TextValuePrint>ณ {data.venue}</TextValuePrint>
                  )}
                  <Box
                     {...CenterSpace}
                     justifyContent={'end'}
                     style={{ placeContent: 'start' }}
                  >
                     <TextValuePrint>คะแนนที่จะได้รับ : </TextValuePrint>
                     <Box {...CenterSpace} justifyContent={'space-evenly'}>
                        <PointPrintGSB
                           G={data.gPointPerPerson}
                           S={data.sPointPerPerson}
                           B={data.bPointPerPerson}
                        />
                     </Box>
                  </Box>
               </Box>
            </Box>
         </PaperPrint>
      </div>
   </div>
);

const IconTitle = ({ icon, text }) => (
   <React.Fragment>
      <FontAwesomeIcon icon={icon} color={Layout.primary} />
      <MySpan>{text}</MySpan>
   </React.Fragment>
);
const PointGSB = ({ G, S, B }) => (
   <React.Fragment>
      <Box>
         <MyChip bgColor={'rgb(238,210,35)'}>for SOCIETY</MyChip>
         <DataSpan>{B}</DataSpan>
      </Box>
      <span>
         <MyChip bgColor={'rgb(234,24,145)'}>with GOVERNANCE</MyChip>
         <DataSpan>{G}</DataSpan>
      </span>
      <Box>
         <MyChip bgColor={'rgb(135,70,60)'}>through DIGITALIZATION</MyChip>
         <DataSpan>{S}</DataSpan>
      </Box>
   </React.Fragment>
);
const PointPrintGSB = ({ G, S, B }) => (
   <React.Fragment>
      {G ? (
         <Box>
            <DataSpan margin={'0 5px'}>{G}</DataSpan>
            <MyChipPrint bgColor={'rgb(234,24,145)'}>G</MyChipPrint>
         </Box>
      ) : (
         ''
      )}
      {S ? (
         <Box>
            <DataSpan margin={'0 5px'}>{S}</DataSpan>
            <MyChipPrint bgColor={'rgb(135,70,60)'}>S</MyChipPrint>
         </Box>
      ) : (
         ''
      )}
      {B ? (
         <Box>
            <DataSpan margin={'0 5px'}>{B}</DataSpan>
            <MyChipPrint bgColor={'rgb(238,210,35)'}>B</MyChipPrint>
         </Box>
      ) : (
         ''
      )}
   </React.Fragment>
);
const ValuePerson = ({ value }) => (
   <DataSpan margin={'0  2rem'}>{value}&nbsp;&nbsp;คน</DataSpan>
);
const useStyles = makeStyles((theme) => ({
   paper: {
      // backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      // backgroundColor: "#fff",
      width: '65%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
   listStyle: {
      height: '65px',
   },
   flexGrid: {
      display: 'flex',
      alignItems: 'center',
   },
   qrPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      height: '100%',
      width: '100%',
   },
   detailRight: {
      height: '280px',
      overflow: 'auto',
   },
}));
const View = (props) => {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(true);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const [resp, setResp] = useState(null);
   const [data, setData] = useState({
      activityId: '',
      activityCode: '',
      activityQRCode: '',
      affordableEmployeeName: null,
      ruleName: '',
      isUseLocation: false,
      venue: '',
      creatorEmployeeName: '',
      gPointPerPerson: '',
      sPointPerPerson: '',
      bPointPerPerson: '',
      paidGPoint: '',
      paidSPoint: '',
      paidBPoint: '',
      totalParticipant: '',
      totalScan: '',
      totalPoint: '',
      remainingPoint: '',
      activityName: '',
      activityOwnerOrgEmployeeId: '',
      activityOwnerName: '',
      perCent: '',
      allowMultipleScan: false,
      whitelistDivisions: null,
      blacklistDivisions: null,
      whitelistEmployees: null,
      blacklistEmployees: null,
   });
   const qrRef = useRef();

   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.post('/GSB/dashboard/activity/GetActivity', {
         activityId: props.refID,
      })
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            setIsError({
               error: true,
               errorStatus: e.response.status,
               errorMessage: e.response.data.errorAppMessageTh
                  ? e.response.data.errorAppMessageTh
                  : 'เกิดข้อผิดพลาด',
            });
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   useEffect(() => {
      setActivityData();
   }, [resp]);
   const setActivityData = () => {
      if (resp) {
         setData({
            ...resp,
            data: resp,
            ruleName: resp.ruleNameTh,
            activityName: resp.activityNameTh,
            affordableEmployeeName:
               resp.affordableEmployeeNameTh.length !== 0 &&
               resp.affordableEmployeeNameTh.map((value, idx) => (
                  <div key={value.employeeOrgId}>{value.employeeNameTh}</div>
               )),
            venue: resp.venueTh && resp.venueTh,
            activityOwnerName: resp.activityOwnerNameTh,
            creatorEmployeeName: resp.creatorEmployeeNameTh,
            perCent: Math.fround(
               (resp.remainingPoint / resp.totalPoint) * 100,
            ).toFixed(2),
            whitelistDivisions:
               resp.whitelistDivisions &&
               resp.whitelistDivisions.map((value, key) => (
                  <div key={key}>{value.divisionNameTh}</div>
               )),
            blacklistDivisions:
               resp.blacklistDivisions &&
               resp.blacklistDivisions.map((value, key) => (
                  <div key={key}>{value.divisionNameTh}</div>
               )),
            whitelistEmployees:
               resp.whitelistEmployees &&
               resp.whitelistEmployees.map((value, key) => (
                  <div key={key}>{value.employeeNameTh}</div>
               )),
            blacklistEmployees:
               resp.blacklistEmployees &&
               resp.blacklistEmployees.map((value, key) => (
                  <div key={key}>{value.employeeNameTh}</div>
               )),
         });
         setIsLoading(false);
      }
   };
   const handleEdit = () => {
      props.onClickEdit(data);
   };
   const handleDelete = () => {
      props.onClickDelete(data);
   };
   if (isLoading) return <LoadingPopup />;
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <div className={classes.header}>
            <Box
               display={'flex'}
               justifyContent={'center'}
               alignItems={'center'}
               alignContent={'center'}
            >
               <Typography variant={'h4'}>รายละเอียดกิจกรรม</Typography>
               <Tooltip title='Edit'>
                  <IconButton aria-label='แก้ไข' onClick={handleEdit}>
                     <FontAwesomeIcon color={'#00a2e8'} icon={faFileEdit} />
                  </IconButton>
               </Tooltip>
               <Tooltip title='Delete'>
                  <IconButton aria-label='ลบ' onClick={handleDelete}>
                     <FontAwesomeIcon color={'#ed1c24'} icon={faTrashAlt} />
                  </IconButton>
               </Tooltip>
            </Box>
            <IconButton
               className={classes.headerL}
               size={'small'}
               onClick={props.onClickClose}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <Box
            display={'flex'}
            alignItems={'flex-start'}
            flexDirection={'column'}
            fontSize={20}
         >
            <Box
               display={'flex'}
               justifyContent={'space-around'}
               alignItems={'center'}
               alignContent={'center'}
            >
               <Box width={1 / 2}>
                  <Box>
                     <Box textAlign={'center'}>
                        <Circle series={[data.perCent]} />
                        <Typography variant={'body1'}>
                           {`คะแนนกิจกรรมคงเหลือ ${data.remainingPoint}/${data.totalPoint} คะแนน`}
                        </Typography>
                     </Box>
                  </Box>
               </Box>
               <Divider orientation={'vertical'} flexItem light />
               <Box width={1 / 2} className={classes.detailRight}>
                  <Box py={1} px={3}>
                     <Grid container>
                        {data.activityCode && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 รหัสกิจกรรม
                              </Grid>
                              <Grid item xs={6}>
                                 {data.activityCode}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.activityStatusDesc && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 สถานะกิจกรรม
                              </Grid>
                              <Grid item xs={6}>
                                 <ActLable
                                    StatusType={data.activityStatusDesc}
                                 />
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.activityName && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 ชื่อกิจกรรม
                              </Grid>
                              <Grid item xs={6}>
                                 {data.activityName}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.activityOwnerName && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 เจ้าของกิจกรรม
                              </Grid>
                              <Grid item xs={6}>
                                 {data.activityOwnerName}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.affordableEmployeeName && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 พนักงานที่สามารถให้คะแนน
                              </Grid>
                              <Grid item xs={6}>
                                 {data.affordableEmployeeName}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.ruleCode && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 รหัสหลักเกณฑ์
                              </Grid>
                              <Grid item xs={6}>
                                 {data.ruleCode}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.ruleName && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 หลักเกณฑ์
                              </Grid>
                              <Grid item xs={6}>
                                 {data.ruleName}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.venue && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 สถานที่จัดกิจกรรม
                              </Grid>
                              <Grid item xs={6}>
                                 {data.venue}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.creatorEmployeeName && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 พนักงานที่สร้างกิจกรรม
                              </Grid>
                              <Grid item xs={6}>
                                 {data.creatorEmployeeName}
                              </Grid>
                           </React.Fragment>
                        )}
                        <Grid item xs={6}>
                           วันที่สร้างกิจกรรม
                        </Grid>
                        <Grid item xs={6}>
                           {dayjs(new Date(data.activityCreatedDate)).format(
                              'DD/MM/BBBB HH:mm',
                           )}
                        </Grid>
                        <Grid item xs={6}>
                           ระยะเวลาของกิจกรรม
                        </Grid>
                        <Grid item xs={6}>
                           {`${dayjs(new Date(data.startDate)).format(
                              'DD/MM/BBBB HH:mm',
                           )} - ${dayjs(new Date(data.endDate)).format(
                              'DD/MM/BBBB HH:mm',
                           )}`}
                        </Grid>
                        {data.whitelistEmployees && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 Whitelist พนักงาน
                              </Grid>
                              <Grid item xs={6}>
                                 {data.whitelistEmployees}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.blacklistEmployees && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 Blacklist พนักงาน
                              </Grid>
                              <Grid item xs={6}>
                                 {data.blacklistEmployees}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.whitelistDivisions && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 Whitelist สังกัด
                              </Grid>
                              <Grid item xs={6}>
                                 {data.whitelistDivisions}
                              </Grid>
                           </React.Fragment>
                        )}
                        {data.blacklistDivisions && (
                           <React.Fragment>
                              <Grid item xs={6}>
                                 Blacklist สังกัด
                              </Grid>
                              <Grid item xs={6}>
                                 {data.blacklistDivisions}
                              </Grid>
                           </React.Fragment>
                        )}
                     </Grid>
                  </Box>
               </Box>
            </Box>
            <br />
            <Box width={'100%'}>
               <Grid container spacing={2}>
                  <Grid item lg={9} xs={12}>
                     <Paper elevation={3}>
                        <Box>
                           <List aria-label={'mailbox folders'}>
                              <ListItem divider className={classes.listStyle}>
                                 <Grid container>
                                    <Grid
                                       item
                                       xs={3}
                                       className={classes.flexGrid}
                                    >
                                       <IconTitle
                                          icon={faStar}
                                          text={'จำนวนคะแนนที่ให้ต่อคน'}
                                       />
                                    </Grid>
                                    <Grid item xs={9}>
                                       <Box
                                          {...CenterSpace}
                                          justifyContent={'space-evenly'}
                                       >
                                          <PointGSB
                                             B={data.bPointPerPerson}
                                             G={data.gPointPerPerson}
                                             S={data.sPointPerPerson}
                                          />
                                       </Box>
                                    </Grid>
                                 </Grid>
                              </ListItem>
                              <ListItem divider className={classes.listStyle}>
                                 <Grid container>
                                    <Grid
                                       item
                                       xs={3}
                                       className={classes.flexGrid}
                                    >
                                       <IconTitle
                                          icon={faStar}
                                          text={'จำนวนคะแนนที่ให้ไปทั้งหมด'}
                                       />
                                    </Grid>
                                    <Grid item xs={9}>
                                       <Box
                                          {...CenterSpace}
                                          justifyContent={'space-evenly'}
                                       >
                                          <PointGSB
                                             B={data.paidBPoint}
                                             G={data.paidGPoint}
                                             S={data.paidSPoint}
                                          />
                                       </Box>
                                    </Grid>
                                 </Grid>
                              </ListItem>
                              <ListItem className={classes.listStyle}>
                                 <Grid container>
                                    <Grid
                                       item
                                       xs={3}
                                       className={classes.flexGrid}
                                    >
                                       <IconTitle
                                          icon={faUser}
                                          text={'จำนวนผู้เข้าร่วมกิจกรรม'}
                                       />
                                    </Grid>
                                    <Grid item xs={9}>
                                       <ValuePerson value={data.totalScan} />
                                       <FormControlLabel
                                          control={
                                             <Checkbox
                                                checked={data.allowMultipleScan}
                                                disabled
                                                name={'canJoin'}
                                                color={'primary'}
                                                size={'small'}
                                             />
                                          }
                                          label={
                                             'สามารถเข้าร่วมกิจกรรมได้มากกว่า 1 ครั้ง'
                                          }
                                       />
                                    </Grid>
                                 </Grid>
                              </ListItem>
                           </List>
                        </Box>
                     </Paper>
                  </Grid>
                  <Grid item lg={3} xs={12}>
                     <Paper elevation={3} className={classes.qrPaper}>
                        <Box p={2}>
                           <Box {...CenterSpace}>
                              <Box>
                                 <Typography variant={'h6'}>QR CODE</Typography>
                              </Box>
                              <Box>
                                 <ReactToPrint
                                    documentTitle={data.activityName}
                                    trigger={() => (
                                       <Button
                                          variant={'outlined'}
                                          color={'primary'}
                                          startIcon={
                                             <FontAwesomeIcon icon={faPrint} />
                                          }
                                       >
                                          พิมพ์
                                       </Button>
                                    )}
                                    content={() => qrRef.current}
                                 />
                              </Box>
                           </Box>
                           <br />
                           <Box>
                              <QRCode
                                 value={data.activityQRCode}
                                 logoImage={Logo}
                              />
                           </Box>
                        </Box>
                     </Paper>
                  </Grid>
               </Grid>
               <ComponentToPrint
                  documentTitle={data.activityName}
                  printRef={qrRef}
                  valueQR={data.activityQRCode}
                  nameActivity={data.activityName}
                  data={data}
               />
            </Box>
         </Box>
      </Paper>
   );
};

export default View;
